import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { AppEnvironment, CustomTranslationLoader } from '@coin/shared/core/data-access-translation-loader';
import { TopicActionBarComponent } from './topic-action-bar.component';

@NgModule({
  declarations: [TopicActionBarComponent],
  imports: [
    TranslateModule.forChild(CustomTranslationLoader.createConfig(AppEnvironment.Customer)),
    CommonModule,
    MatIconModule,
    FormsModule
  ],
  exports: [TopicActionBarComponent]
})
export class TopicActionBarModule {}
